import { Box, Button, ButtonGroup, Grid, Icon, IconButton, ListItem, makeStyles, MenuItem, TextField, Typography, useTheme } from "@mui/material";
import DOMPurify from "dompurify";
import { ReactNode } from "react";
import FallbackSpinner from "../../../../materio/@core/components/spinner";
import PageHeader from "../../../../materio/@core/components/page-header";
import useSummary from "../hooks/useSummary";
import WizardStep from "../../../../components/Wizard/WizardStep";

type Props = {
    text: string,
    contentType: 'SalesPitch',
    onClose: () => void
}

function createMarkup(html: string) {
    return {
        __html: DOMPurify.sanitize(html)
    }
}

const AISummarizeText = ({ text, contentType, onClose }: Props) => {
    const { result, isReviewing } = useSummary(text, contentType);

    const renderText = () => {
        var nodes = [] as ReactNode[];

        for (var i = 0; i < result.length; i++) {
            const section = result[i];

            nodes.push((
                <TextField value={section.text} multiline rows={23} fullWidth />
            ))
        }

        return nodes;
    }

    return (
        <WizardStep onFinish={onClose} onCancel={onClose}>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <PageHeader
                        title={<Typography variant='h5'>{isReviewing && <span>Analyzing text, please wait..</span>} {!isReviewing && <span>Text Summary</span>}</Typography>}
                        subtitle={
                            isReviewing && <Typography variant='body2'>
                                This may take a few minutes
                            </Typography>
                        }
                    />
                </Box>

                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <Box sx={{ minHeight: 50, flex: 1, overflow: 'auto' }}>
                        {!isReviewing && <Grid container>{renderText()}</Grid>}
                        {isReviewing && <FallbackSpinner sx={{ height: '100%' }} />}
                    </Box>
                </Box>
            </Box>
        </WizardStep>
    )
}

export default AISummarizeText;